import { infiniteQueryOptions, queryOptions } from "@tanstack/react-query";

import { ContentLanguageHeaderName } from "@/api/ApiClientProvider";
import { useApi } from "@/api/hooks/useApi";
import { commonAPIDataSelector } from "@/helpers/Network/selectors";
import { useProjectId } from "@/hooks/Network/useProjectId";
import { QUERY_KEYS } from "@/query-keys";
import type { EntityDetailsQueryOptions } from "@/types/query-types";

export const useServiceQueries = () => {
  const api = useApi();
  const projectId = useProjectId();

  return {
    listInfinite: () => {
      const limit = 12;

      return infiniteQueryOptions({
        queryKey: QUERY_KEYS.SERVICE_PARTNERS_ALL_INFINITE(projectId),
        queryFn: ({ pageParam = 0 }) =>
          api
            .getServicepartnersV1({
              includeFromConnection: true,
              returnAllowedTypes: true,
              Limit: limit,
              Offset: pageParam * limit,
            })
            .then((items) => commonAPIDataSelector(items)),
        initialPageParam: 0,
        getNextPageParam: (lastPage, pages) => (lastPage?.hasMore ? pages?.length : undefined),
      });
    },
    details: ({ serviceId }: { serviceId: string }, options?: EntityDetailsQueryOptions) => {
      const headers = {
        [ContentLanguageHeaderName]: options?.translationMode || "default",
      };

      return queryOptions({
        queryKey: QUERY_KEYS.SERVICE_PARTNER(projectId, serviceId, options),
        queryFn: () =>
          api.getServicepartnersDetailsV1(serviceId, undefined, {
            headers,
          }),
        select: commonAPIDataSelector,
        staleTime: 5 * 60 * 1000, // 5 minutes
      });
    },
  };
};
